<template>
  <div class="container">
    <div class="row resent-articles-block">
      <preview-article
        v-for="(article, index) in articles"
        class="col-md-3 col-sm-6 col-12"
        :img_src="article.img_src"
        :lazy_img_src="article.lazy_img_src"
        :title="article.title"
        :text="article.text"
        :date="article.date"
        :href_to="article.href_to"
        :key="`preview-article_${uid}-${index}`"
      />
    </div>
  </div>
</template>

<script>
import PreviewArticle from "../parts/builder/PreviewArticle.vue";

export default {
  name: "ResentArticlesBlock",
  components: {PreviewArticle},
  props: {
    /**props**/
    articles: {
      type: Array,
      default: () => [],
      admin_type: 'array',
      array_values: {
        img_src: {
          type: String,
          default: '/images/uploads-main-slide.jpeg',
          admin_type: 'image',
        },
        lazy_img_src: {
          type: String,
          default: '',
          admin_type: 'image',
        },
        title: {
          type: String,
          default: '',
          admin_type: 'input',
        },
        text: {
          type: String,
          default: '',
          admin_type: 'input',
        },
        date: {
          type: String,
          default: '',
          admin_type: 'date',
        },
        href_to: {
          type: String,
          default: '',
          admin_type: 'input',
        },
      },
    },
    category_href: {
      type: String,
      default: '',
      admin_type: 'input',
    }
    /**props**/
  },
  computed: {
    uid() {
      return this._uid
    }
  }
}
</script>
